import { canUseDOM } from '@ps/web-core-utils';
import { Translation } from '@ps/web-shared-components';
import React from 'react';

import BannerNotification from '../../../components/BannerNotification/BannerNotification';

import { TXTWCL_XXBrandXX_is_not_supported_on__ELL } from './BrowserNotification.messages.json';

const BrowserNotification: React.FC = () => {
  let show = false;
  if (canUseDOM) {
    const { userAgent } = window.navigator;
    show = userAgent.includes('MSIE ') || userAgent.includes('Trident/');
  }

  return show ? (
    <BannerNotification position="top">
      <Translation tagName="p" {...TXTWCL_XXBrandXX_is_not_supported_on__ELL} />
    </BannerNotification>
  ) : null;
};

export default BrowserNotification;
